import React, { ChangeEvent, FC, useMemo } from 'react';
import momentTz from 'moment-timezone';
import { FieldErrorList, FormField, Input, Label, TextArea, DatePicker } from 'common/components';
import { InputType } from 'common/enums';
import { FieldError } from 'common/models';

import { CompanyInfoField } from 'modules/data-management/enums/data-management.enum';

import './CompanyFootprintForm.scss';

type CompanyFootprintFormProps = {
    source: string;
    description: string;
    year: string;
    fieldErrors: Array<FieldError>;
    handleSourceNameChange: (event: ChangeEvent<HTMLInputElement>) => void;
    handleDescriptionChange: (event: ChangeEvent<HTMLTextAreaElement>) => void;
    handleYearChange: (value: Date) => void;
};

const CompanyFootprintForm: FC<CompanyFootprintFormProps> = ({
    source,
    description,
    year,
    fieldErrors,
    handleSourceNameChange,
    handleDescriptionChange,
    handleYearChange
}) => {
    const getDate = useMemo(() => {
        if (year) {
            const formatDate = momentTz(year, 'YY-MMM').toDate();
            return formatDate;
        }
    }, [year]);

    return (
        <>
            <div className="company-footprint-top-section">
                <FormField className="company-footprint-form-field">
                    <Label text="Source (required)"></Label>
                    <Input
                        type={InputType.TEXT}
                        value={source}
                        onChange={handleSourceNameChange}
                        onBlur={handleSourceNameChange}
                    />
                    <FieldErrorList field={CompanyInfoField.Source} errors={fieldErrors} />
                </FormField>
                <FormField className="company-footprint-form-field-right">
                    <DatePicker
                        label="Source Date (required)"
                        className="session-date-picker"
                        showLeadingZeros={true}
                        value={getDate}
                        onChange={(val: any) => handleYearChange(val)}
                        format="MM/yyyy"
                        yearPlaceholder="YYYY"
                        monthPlaceholder="MM"
                        onKeyDown={(e) => {
                            e.preventDefault();
                        }}
                        clearIcon={null}
                        maxDate={new Date()}
                    />
                    <FieldErrorList field={CompanyInfoField.Year} errors={fieldErrors} />
                </FormField>
            </div>
            <div>
                <FormField className="company-footprint-form-field-right">
                    <Label text="Description (required)"></Label>
                    <TextArea
                        value={description}
                        onChange={handleDescriptionChange}
                        onBlur={handleDescriptionChange}
                    />
                    <FieldErrorList field={CompanyInfoField.Description} errors={fieldErrors} />
                </FormField>
            </div>
        </>
    );
};

export default CompanyFootprintForm;
